import FetchHelper from '../helpers/fetch_helper';

const UserSettingValuesDispatcher = {
  async fetchUserSettingValues(userId) {
    try {
      const response = await FetchHelper.fetchJson(`user-setting-values?userId=${userId}`, { method: 'GET' });
      this.setStoreVal('userSettingValues', response.results);
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: `Could not retrieve user setting values for user ${userId}` },
      });
    }
  },
};
export default UserSettingValuesDispatcher;
